import CopyToClipboard from '@src/components/CopyToClipboard'
import UpArrowCorner from '@src/components/icons/UpArrowCorner'
import { truncateAddress } from '@src/utils/truncateAddress'

export interface SourceTxComponentProps {
    sourceTxHash?: string
}

export const SourceTxComponent: React.FC<SourceTxComponentProps> = ({ sourceTxHash }) => {
    const formattedSourceTxHash =
        sourceTxHash && truncateAddress(sourceTxHash.substring(sourceTxHash.lastIndexOf('/') + 1) || '')
    const sourceTxHashURL = sourceTxHash?.substring(sourceTxHash.lastIndexOf('/') + 1)

    return (
        <div className='flex items-center justify-between'>
            <span className='text-sm text-mach-sub-text'>Source Id</span>
            <div className='flex items-center gap-[6px]'>
                <CopyToClipboard anchorId='source-tx-hash' textToCopy={sourceTxHashURL || ''} />
                <span className='text-sm'>{formattedSourceTxHash}</span>
                <a
                    className='flex cursor-pointer text-mach-sub-text'
                    href={sourceTxHash}
                    target='_blank'
                    rel='noreferrer'
                >
                    <UpArrowCorner className='h-3 w-3' />
                </a>
            </div>
        </div>
    )
}
